import React from 'react';
import Typography from '@mui/material/Typography';
import { useLocalization, useTranslate } from '@im/react-localization';
import Box from '@mui/material/Box';

type Props = {
  date: string;
  etaEllipsis?: boolean;
  quantity: number;
  tooltipsShow?: boolean;
};

export default function WarehouseETAExpectedShip(props: Props) {
  const translate = useTranslate();
  const { formatDate } = useLocalization();
  const parseDate = (dateString: string) => {
    return formatDate(dateString, 'dd/MM/yyyy');
  };
  return (
    <>
      {!props.tooltipsShow ? (
        <div
          style={{
            maxWidth: props.etaEllipsis ? '65px' : 'auto',
            overflow: props.etaEllipsis ? 'hidden' : 'none',
            textOverflow: props.etaEllipsis ? 'ellipsis' : 'none',
            whiteSpace: props.etaEllipsis ? 'nowrap' : undefined,
          }}
        >
          <Typography
            component="span"
            sx={{ fontSize: '12px', fontWeight: '600' }}
          >
            {props.quantity}
          </Typography>{' '}
          <Typography
            component="span"
            sx={{ fontSize: '12px', fontWeight: '400' }}
          >
            {translate('Warehouse.ETAOutOfStockText')}
          </Typography>{' '}
          {props.date !== undefined &&
          props.date !== null &&
          props.date !== '' ? (
            <Typography
              component="span"
              sx={{ fontSize: '12px', fontWeight: '400' }}
            >
              {parseDate(props.date)}
            </Typography>
          ) : (
            ''
          )}
        </div>
      ) : (
        <>
          <Box>
            <div>
              <Typography
                component="span"
                sx={{ fontSize: '12px', fontWeight: '600' }}
              >
                {props.quantity}
              </Typography>{' '}
              <Typography
                component="span"
                sx={{ fontSize: '12px', fontWeight: '400' }}
              >
                {translate('Warehouse.ETAOutOfStockText')}
              </Typography>{' '}
              {props.date !== undefined &&
              props.date !== null &&
              props.date !== '' ? (
                <Typography
                  component="span"
                  sx={{ fontSize: '12px', fontWeight: '400' }}
                >
                  {parseDate(props.date)}
                </Typography>
              ) : (
                ''
              )}
            </div>
          </Box>
        </>
      )}
    </>
  );
}
